/**
 * Where the per-environment configuration is served from.
 *
 * Under `assets/` because that is what the deployment mounts over: the Helm
 * chart writes its ConfigMap to `/usr/share/nginx/html/assets/config/…`, and a
 * file the application reads from anywhere else is the one baked into the
 * image — the same one in every environment.
 */
export const CONFIGURATION_PATH = '/assets/config/';
